import { Parameter } from '@src/main/modules/parameters/domain/parameters-management/parameter.interface';
import ParameterSection from '@src/main/modules/parameters/ui/parameters-management/components/ParametersSection';
import { FC } from 'react';

interface ParameterSectionContainerProps {
  title: string;
  parameters: Parameter[];
  editMode: boolean;
  hasEditPermission: boolean;
  onEdit: () => void;
  onAccept: () => void;
  onRefuse: () => void;
  onChange: (param: Parameter, value: string | boolean) => void;
  onRefresh: () => void;
  type?: 'text' | 'textarea' | 'switch';
}

const ParameterSectionContainer: FC<ParameterSectionContainerProps> = ({
  title,
  parameters,
  editMode,
  hasEditPermission,
  onEdit,
  onAccept,
  onRefuse,
  onChange,
  onRefresh,
  type = 'text',
}) => (
  <ParameterSection
    title={title}
    parameters={parameters}
    editMode={editMode}
    onEdit={onEdit}
    onAccept={onAccept}
    onRefuse={onRefuse}
    onChange={onChange}
    onRefresh={onRefresh}
    hasEditPermission={hasEditPermission}
    type={type}
  />
);
export default ParameterSectionContainer;
